import { render } from "./TransAssetsIndex.vue?vue&type=template&id=000d8b74"
import script from "./TransAssetsIndex.vue?vue&type=script&lang=js"
export * from "./TransAssetsIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue-project\\asset-labuhan-digital\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__